import { render, staticRenderFns } from "./ServiceTypeByStatus.vue?vue&type=template&id=2bee1fbe"
import script from "./ServiceTypeByStatus.vue?vue&type=script&lang=ts"
export * from "./ServiceTypeByStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports